var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransitionToGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 292,
    viewBox: "0 0 316 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 158,
    cy: 265,
    rx: 158,
    ry: 27,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.507 92.133C108.228 101.093 103.264 108.886 96.7544 115.29C89.3433 122.581 79.6443 128.37 67.9141 132.504C67.5258 132.637 67.1307 132.749 66.7216 132.832C66.1878 132.937 65.647 132.993 65.1063 133H65.0023C64.4269 133 63.8515 132.944 63.283 132.832C62.8809 132.749 62.4857 132.637 62.0975 132.511C50.3603 128.384 40.6405 122.595 33.2224 115.311C26.7126 108.907 21.7487 101.121 18.4695 92.1609C12.5073 75.8685 12.847 57.9211 13.1243 43.5003L13.1313 43.2769C13.1867 42.0827 13.2214 40.8327 13.2422 39.4569C13.3392 32.676 18.6983 27.0613 25.43 26.6842C39.4689 25.8951 50.3325 21.279 59.6155 12.1727L59.6987 12.0958C61.2378 10.6712 63.179 9.97287 65.1132 10.0008C66.9781 10.0218 68.8292 10.7201 70.3197 12.0958L70.396 12.1727C79.679 21.286 90.5426 25.8951 104.582 26.6842C111.313 27.0613 116.672 32.676 116.769 39.4569C116.79 40.8466 116.825 42.0967 116.88 43.2769V43.3676C117.151 57.8094 117.483 75.7917 111.507 92.133Z",
    fill: "#0077C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72C96 89.0535 82.1524 102.936 65.113 103H65C47.9112 103 34 89.0959 34 72C34 54.9112 47.9112 41 65 41H65.1059C82.1524 41.0636 96 54.9465 96 72Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56C61.1413 56 58 59.037 58 62.7677V64.4108V70H61.5035V64.4108V62.7677C61.5035 60.9024 63.0706 59.3872 65 59.3872C66.9294 59.3872 68.4965 60.9024 68.4965 62.7677V64.4108V70H72V64.4108V62.7677C72 59.0303 68.8587 56 65 56Z",
    fill: "#77BBE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1691 87H55.8309C54.817 87 54 86.2356 54 85.302V71.698C54 70.7577 54.8243 70 55.8309 70H74.1691C75.183 70 76 70.7644 76 71.698V85.302C76 86.2423 75.183 87 74.1691 87Z",
    fill: "#0077C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5015 80H63.4985C62.6687 80 62 79.3247 62 78.5C62 77.6753 62.6746 77 63.4985 77H66.5015C67.3313 77 68 77.6753 68 78.5C68 79.3247 67.3313 80 66.5015 80Z",
    fill: "#77BBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8667 259.363C90.9666 259.363 85.3463 253.743 85.3463 246.844V56.2731C85.3463 49.3737 90.9666 43.7539 97.8667 43.7539H185.509C192.409 43.7539 198.03 49.3737 198.03 56.2731V246.844C198.03 253.743 192.409 259.363 185.509 259.363H97.8667Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.145 44.7771C191.255 44.7771 196.229 49.7619 196.229 55.8854V246.115C196.229 252.238 191.255 257.223 185.145 257.223H97.8554C91.7452 257.223 86.7711 252.238 86.7711 246.115V55.8854C86.7711 49.7619 91.7452 44.7771 97.8554 44.7771H185.145ZM185.145 42H97.8554C90.2003 42 84 48.2137 84 55.8854V246.115C84 253.786 90.2003 260 97.8554 260H185.145C192.8 260 199 253.786 199 246.115V55.8854C199 48.2206 192.793 42 185.145 42Z",
    fill: "#0065AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.104 54H127.903C125.845 54 123.912 52.9988 122.693 51.3018L116 42H167L160.307 51.3018C159.095 52.9988 157.162 54 155.104 54Z",
    fill: "#0065AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.649 49H166.93L163.304 53.8895C161.425 56.4312 158.439 57.9272 155.273 57.9272H127.95C124.776 57.9272 121.798 56.4312 119.919 53.8895L116.293 49H98.3514C93.7372 49 90 52.7191 90 57.3108V245.689C90 250.281 93.7372 254 98.3514 254H184.649C189.263 254 193 250.281 193 245.689V57.3108C193 52.726 189.256 49 184.649 49Z",
    fill: "#CFECFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.75 113H105.25C102.352 113 100 110.536 100 107.5C100 104.464 102.352 102 105.25 102H178.75C181.648 102 184 104.464 184 107.5C184 110.536 181.648 113 178.75 113Z",
    fill: "#77BBE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.25 76H101.75C100.784 76 100 76.896 100 78C100 79.104 100.784 80 101.75 80H168.25C169.216 80 170 79.104 170 78C170 76.896 169.216 76 168.25 76Z",
    fill: "#0077C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.25 87H101.75C100.784 87 100 87.896 100 89C100 90.104 100.784 91 101.75 91H133.25C134.216 91 135 90.104 135 89C135 87.888 134.216 87 133.25 87Z",
    fill: "#0077C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140 87C138.896 87 138 87.896 138 89C138 90.104 138.896 91 140 91C141.104 91 142 90.104 142 89C142 87.888 141.104 87 140 87Z",
    fill: "#0077C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147 87C145.896 87 145 87.896 145 89C145 90.104 145.896 91 147 91C148.104 91 149 90.104 149 89C149 87.888 148.104 87 147 87Z",
    fill: "#0077C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154 87C152.896 87 152 87.896 152 89C152 90.104 152.896 91 154 91C155.104 91 156 90.104 156 89C156 87.888 155.112 87 154 87Z",
    fill: "#0077C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.1 221H90V131H215.1C222.78 131 229 137.196 229 144.846V207.154C229 214.804 222.773 221 215.1 221Z",
    fill: "#77BBE9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.115 148H90V165.362H229.115V148Z",
    fill: "#0077C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199 207C202.866 207 206 203.866 206 200C206 196.134 202.866 193 199 193C195.134 193 192 196.134 192 200C192 203.866 195.134 207 199 207Z",
    fill: "#0077C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209 207C212.866 207 216 203.866 216 200C216 196.134 212.866 193 209 193C205.134 193 202 196.134 202 200C202 203.866 205.134 207 209 207Z",
    fill: "#CFECFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.134 200.529C99.9394 200.529 99.7864 200.376 99.7864 200.182C99.7864 199.987 99.9394 199.835 100.134 199.835H166.214C166.409 199.835 166.562 199.987 166.562 200.182C166.562 200.376 166.409 200.529 166.214 200.529H100.134Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.25 198H99.75C98.784 198 98 198.896 98 200C98 201.104 98.784 202 99.75 202H166.25C167.216 202 168 201.104 168 200C168 198.896 167.216 198 166.25 198Z",
    fill: "#0077C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.751 113H105.249C102.352 113 100 110.536 100 107.5C100 104.464 102.352 102 105.249 102H136.751C139.648 102 142 104.464 142 107.5C142 110.536 139.648 113 136.751 113Z",
    fill: "#0077C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.99 10.0907L190.907 15.1812L187.186 25.89L150.035 7.30589L157.554 6.73642L189.711 9.43098L190.99 10.0907Z",
    fill: "#0077C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M191.95 0V10.1463L155.37 7.82672L192.242 15.452V25.4316L150.028 7.3128L191.95 0Z",
    fill: "#77BBE9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.706 15.6256C199.706 15.6256 201.257 15.9104 203.775 16.5423",
    stroke: "#0077C8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.607 18.8203C224.475 23.1052 243.263 32.1125 243.965 48.3493C245.037 73.1211 270.919 63.1832 288.837 87.8023C304.745 109.657 306.769 130.547 297.386 149.617C291.757 161.245 271.7 182.3 236.5 173.5",
    stroke: "#0077C8",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "11.73 11.73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitionToGateway);
export default __webpack_public_path__ + "static/media/TransitionToGateway.03e57b459aafe56f5655eeb36139de1c.svg";
export { ForwardRef as ReactComponent };